export const clarioApi = async (
    url,    
    data,
    textControl, 
    abortControllerRef,
) => {
    try{
    let buffer = ""; // 이벤트 데이터를 누적할 버퍼

    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(data),
        cache: "no-cache",
        signal: abortControllerRef?.signal,
    });
    if(response.body) {
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

while (true) {
  const { done, value } = await reader.read();
  if (done) break;

  const chunk = decoder.decode(value, { stream: true });
            buffer += chunk;

            let boundaryIndex;
            while ((boundaryIndex = buffer.indexOf("\n\n")) !== -1) {
                const rawEvent = buffer.slice(0, boundaryIndex);
                buffer = buffer.slice(boundaryIndex + 2);

                if (!rawEvent.trim()) continue;

                const lines = rawEvent.split("\n");
                let eventType = null;
                let eventData = null;

                for (const line of lines) {
                if (line.startsWith("event: ")) {
                    eventType = line.slice(7).trim();
                } else if (line.startsWith("data: ")) {
                    eventData = line.slice(6).trim();
                }
                }

                try {
                const parsedData = JSON.parse(eventData);
                if (eventType === "ClarioStatus" || eventType === "ClarioResponse") {
                    if(
                        parsedData?.type === 'DONE' ||
                        parsedData?.type === 'main' ||
                        parsedData?.type === "sub" ||
                        parsedData?.type === "FINISH"
                    ) {
                        await new Promise((resolve) => setTimeout(resolve, 40));
                    } if (parsedData?.type === "FINISH") {
                        await new Promise((resolve) => setTimeout(resolve, 80));
                      }
                    textControl(parsedData);
                } else if (eventType === "ClarioMessageID" ) {
                    const parsedData = JSON.parse(eventData);
                    const prevID = 
                    textControl({ type: "ip", ip: parsedData?.text });
                }
                } catch (err) {
                console.error("❌ JSON parse error:", err, eventData);
                }
            }

            if (abortControllerRef?.signal.aborted) return "aborted";
            }
    }
    return "success";
    }catch (error) {
        console.log(error)
        if (error instanceof Error && error.name === "AbortError") {
        return "aborted";
        }
        return "error";
    }
}